<template>
  <b-modal class="modal-md" id="alertMessage" ref="alertMessage-modal" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="closeAlert()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'money-check']" size="1x" class="mr-2"/>{{ t('paymentAlertText', 'paymentAlertText') }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="closeAlert()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <h5>{{ t('highlightedDocsNotElligibleError', 'highlightedDocsNotElligibleError') }}</h5>
      <!-- <h5>Please untick the documents highlighted in red. They are not elligible for payments.</h5> -->
      <ul class="pl-3">
        <li>{{ t('cantPayForPaidDocsText', 'cantPayForPaidDocsText') }}</li>
        <li v-if="$props.forbiddenDocTypes && Object.keys($props.forbiddenDocTypes).length > 0">{{ t('cantPayForListedDocTypesText', 'cantPayForListedDocTypesText') }}: 
          <span style="font-weight: 600;" v-for="userDocType in $props.forbiddenDocTypes" :key="userDocType">
            {{ userDocType }} 
          </span>
        </li>
      </ul>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <div>
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary mr-2" type="button" @click="closeAlert()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('closeText', 'closeText') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalAlertMessage',
  props: ['forbiddenDocTypes'],
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    closeAlert() {
      this.$parent.closeAlert()
    },
  },
  created() {

  },
  components: {
    
  }
}
</script>

<style scoped>
.flex-align {
  display: flex;
  align-items: center;
}

.remove-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
</style>
